export default "__VITE_ASSET__n612wzIY__"